import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import FadeIn from "../components/FadeIn";
import { CATEGORIES, SERVICES, PACKAGES } from "../data/salon";

export default function Preturi() {
  return (
    <main data-testid="pricing-page">
      {/* Hero */}
      <section className="pt-40 pb-20 md:pt-48 md:pb-28">
        <div className="mx-auto max-w-[1100px] px-6 md:px-12 text-center">
          <FadeIn>
            <p className="eyebrow mb-6">— Prețuri —</p>
          </FadeIn>
          <FadeIn delay={120}>
            <h1
              data-testid="pricing-headline"
              className="font-serif-display text-5xl sm:text-6xl lg:text-7xl leading-[1.05]"
              style={{ color: "#1A1A1A", fontWeight: 300 }}
            >
              Transparență, <span style={{ fontStyle: "italic", color: "#B8964E" }}>fără compromis</span>.
            </h1>
          </FadeIn>
          <FadeIn delay={240}>
            <p className="mt-8 max-w-2xl mx-auto text-lg leading-relaxed" style={{ color: "#555" }}>
              Prețurile noastre reflectă produsele premium folosite, timpul
              dedicat fiecărei cliente și expertiza echipei. Vezi mai jos
              fiecare categorie sau alege un pachet curatat pentru economie.
            </p>
          </FadeIn>
        </div>
      </section>

      {/* Pricing tables */}
      <section className="pb-20 md:pb-28">
        <div className="mx-auto max-w-[1200px] px-6 md:px-12 flex flex-col gap-20 md:gap-28">
          {CATEGORIES.map((cat, idx) => {
            const list = SERVICES[cat.id] || [];
            return (
              <FadeIn key={cat.id}>
                <div data-testid={`pricing-table-${cat.id}`}>
                  <div className="flex items-end justify-between flex-wrap gap-4 mb-10">
                    <div>
                      <p className="eyebrow mb-3">— {cat.tag} —</p>
                      <h2
                        className="font-serif-display text-4xl sm:text-5xl"
                        style={{ color: "#1A1A1A", fontWeight: 300 }}
                      >
                        {cat.label}
                      </h2>
                    </div>
                    <div
                      className="hidden sm:grid grid-cols-3 gap-12 text-xs tracking-wider-luxe"
                      style={{ color: "#999" }}
                    >
                      <span>SERVICIU</span>
                      <span className="text-center">DURATĂ</span>
                      <span className="text-right">PREȚ</span>
                    </div>
                  </div>

                  <ul className="flex flex-col" style={{ borderTop: "1px solid #E8E0D5" }}>
                    {list.map((s, i) => (
                      <li
                        key={s.name}
                        className="grid grid-cols-12 gap-3 py-6 items-baseline transition-colors"
                        style={{ borderBottom: "1px solid #E8E0D5" }}
                      >
                        <div className="col-span-12 sm:col-span-7">
                          <p
                            className="font-serif-display text-xl sm:text-2xl"
                            style={{ color: "#1A1A1A", fontWeight: 300 }}
                          >
                            <span style={{ color: "#B8964E", fontSize: "0.65em", marginRight: "0.6rem", verticalAlign: "middle", letterSpacing: "0.2em" }}>
                              {String(i + 1).padStart(2, "0")}
                            </span>
                            {s.name}
                          </p>
                          <p className="mt-1 text-sm sm:hidden" style={{ color: "#999" }}>
                            {s.duration}
                          </p>
                        </div>
                        <div className="hidden sm:flex col-span-3 justify-center">
                          <span className="text-sm" style={{ color: "#555" }}>{s.duration}</span>
                        </div>
                        <div className="col-span-12 sm:col-span-2 flex justify-start sm:justify-end">
                          <span
                            className="font-serif-display text-2xl"
                            style={{ color: "#B8964E", fontWeight: 400 }}
                          >
                            {s.price}
                            <span className="text-xs ml-1" style={{ color: "#999", letterSpacing: "0.2em" }}>RON</span>
                          </span>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </FadeIn>
            );
          })}
        </div>
      </section>

      {/* Pachete Speciale */}
      <section className="py-24 md:py-32 marble-veined" style={{ borderTop: "1px solid #E8E0D5", borderBottom: "1px solid #E8E0D5" }}>
        <div className="mx-auto max-w-[1300px] px-6 md:px-12">
          <FadeIn>
            <div className="text-center mb-16">
              <p className="eyebrow mb-4">— Pachete Speciale —</p>
              <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl" style={{ color: "#1A1A1A", fontWeight: 300 }}>
                Experiențe <span style={{ fontStyle: "italic", color: "#B8964E" }}>curatate</span>.
              </h2>
              <p className="mt-6 max-w-xl mx-auto text-base leading-relaxed" style={{ color: "#555" }}>
                Combinații atent gândite, cu reduceri exclusive — pentru
                momentele tale speciale.
              </p>
            </div>
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
            {PACKAGES.map((p, i) => (
              <FadeIn key={p.name} delay={i * 120}>
                <div
                  data-testid={`package-card-${i}`}
                  className="lux-card p-9 h-full flex flex-col relative"
                  style={{
                    backgroundColor: p.accent ? "#1A1A1A" : "#FFFFFF",
                    color: p.accent ? "#FAF8F5" : "#1A1A1A",
                    borderColor: p.accent ? "#1A1A1A" : "#E8E0D5",
                  }}
                >
                  {/* Savings badge */}
                  <span
                    className="absolute top-5 right-5 px-3 py-1 text-xs tracking-wider-luxe"
                    style={{
                      backgroundColor: "#B8964E",
                      color: "#FFFFFF",
                    }}
                  >
                    -{p.saved} RON
                  </span>

                  <p className="eyebrow" style={{ color: p.accent ? "#B8964E" : "#B8964E" }}>
                    Pachet
                  </p>
                  <h3
                    className="font-serif-display text-3xl mt-3"
                    style={{ color: p.accent ? "#FAF8F5" : "#1A1A1A", fontWeight: 300 }}
                  >
                    {p.name}
                  </h3>

                  <ul className="mt-7 flex flex-col gap-3 flex-1">
                    {p.items.map((it) => (
                      <li key={it} className="flex items-start gap-3 text-sm">
                        <Check
                          size={14}
                          color={p.accent ? "#B8964E" : "#B8964E"}
                          className="mt-1 shrink-0"
                        />
                        <span style={{ color: p.accent ? "rgba(250,248,245,0.85)" : "#555" }}>
                          {it}
                        </span>
                      </li>
                    ))}
                  </ul>

                  <div
                    className="mt-8 pt-6 flex items-end justify-between"
                    style={{ borderTop: `1px solid ${p.accent ? "rgba(232,224,213,0.15)" : "#E8E0D5"}` }}
                  >
                    <span className="eyebrow" style={{ color: p.accent ? "rgba(250,248,245,0.6)" : "#999" }}>
                      Total
                    </span>
                    <span
                      className="font-serif-display text-3xl"
                      style={{ color: p.accent ? "#FFFFFF" : "#1A1A1A", fontWeight: 400 }}
                    >
                      {p.total}
                      <span className="text-xs ml-1" style={{ color: p.accent ? "rgba(250,248,245,0.6)" : "#999", letterSpacing: "0.2em" }}>
                        RON
                      </span>
                    </span>
                  </div>

                  <Link
                    to="/rezervari"
                    data-testid={`package-cta-${i}`}
                    className="btn-lux mt-8"
                    style={
                      p.accent
                        ? { borderColor: "#B8964E", color: "#FAF8F5" }
                        : {}
                    }
                  >
                    Rezervă pachetul
                    <ArrowUpRight size={14} />
                  </Link>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* Note */}
      <section className="py-20">
        <div className="mx-auto max-w-[800px] px-6 text-center">
          <FadeIn>
            <p
              className="font-serif-display italic text-xl sm:text-2xl leading-relaxed"
              style={{ color: "#555", fontWeight: 300 }}
              data-testid="pricing-note"
            >
              „Prețurile pot varia în funcție de lungimea părului sau complexitatea serviciului. Te vom informa transparent înainte de fiecare programare.”
            </p>
          </FadeIn>
        </div>
      </section>
    </main>
  );
}
